import { Injectable } from '@angular/core';

@Injectable()
export class UtilitiesService {

  constructor() { }

  formatDate(date: Date) {
    return ((date.getMonth() + 1) + '/' + date.getDate() + '/' + date.getFullYear());
  }

  formatCurrency(input: number) {
    return ('$' + input);
  }

}



// WEBPACK FOOTER //
// ./src/app/utilities/utilities.service.ts